export function PhotosIcon(props) {
  const { ...imgAttrs } = props;

  return (
    <img 
      {...imgAttrs}
      className={`profile-icon profile-icon__photos ${imgAttrs.className ? imgAttrs.className : ""}`} 
      src={"https://wvusstatic.com/illustrations/photos.svg"} 
    />
  )
}

export default PhotosIcon;